angular.module('lsnBase.deprecated.models')
  .factory('SalesProfileModel', ['LsnSalesProfileModelV1',
    function(LsnSalesProfileModelV1) {
      return LsnSalesProfileModelV1;
    }
  ]);